import { makeApi } from "@zodios/core";
import { z } from "zod";

const amazonAdvertisingOAuthRequestSchema = z.object({
  amazon_authorization_code: z.string(),
});

// Backend returns empty body on success - status code indicates success/failure
const amazonAdvertisingOAuthResponseSchema = z.unknown();

// Error responses from the backend
const amazonAdvertisingOAuthErrorSchema = z.string();

export const amazonAdvertisingOAuthApiDefinitions = makeApi([
  {
    alias: "exchangeAmazonAdvertisingCode",
    method: "post",
    path: "/api/amazonapi/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: amazonAdvertisingOAuthRequestSchema,
      },
      {
        name: "additional_ads_credentials",
        type: "Query",
        schema: z.boolean().optional(),
      },
      {
        name: "reauthorize",
        type: "Query",
        schema: z.boolean().optional(),
      },
    ],
    response: amazonAdvertisingOAuthResponseSchema,
    errors: [
      {
        status: 400,
        schema: amazonAdvertisingOAuthErrorSchema,
      },
      {
        status: 500,
        schema: amazonAdvertisingOAuthErrorSchema,
      },
    ],
  },
]);
